import React from 'react';
import cookie from 'react-cookies';

import './App.css';


import Search from './search.js'
import Products from './products.js'
import Tabbar from './tabbar.js'
import BottomBanner from './bottombanner.js'
import {requestLog} from './component/functions'

class App extends React.Component {
    constructor(props) {
        //父组件传入参数
        super(props);    
        //当前组件状态
        this.state = {    
            showLogin:false,
        }
    };
    
    componentDidMount(){
        requestLog('post:https://app.moxidata.cn/forest/:forestindex',cookie.load("jwt_v2")).then((data)=>{})
    }

    render(){
        return(
            <div className="body">
				<Tabbar />
				<Search />
				<Products />
				<BottomBanner />
            </div>
        );
    }
        
}


export default App;